import axios from "axios";
import config from "./config";

const axiosInstance = axios.create({
  baseURL: config.apiUrl, // Laravel backend URL
  withCredentials: true, // Ensures cookies are sent with the request
  headers: {
    "X-Requested-With": "XMLHttpRequest", // Tells Laravel it's an AJAX request
  },
});

// Automatically attach CSRF token to requests
axiosInstance.interceptors.request.use((config) => {
  const token = document.cookie
  .split("; ")
  .find((row) => row.startsWith("XSRF-TOKEN="))
  ?.split("=")[1];

if (token) {
  config.headers["X-XSRF-TOKEN"] = decodeURIComponent(token);
}

  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("auth_token");
      window.location.reload(); // Optionally redirect to login
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;